export enum UserRole {
    standard = 'standard',
    admin = 'admin'
}
